<div class="landing-menu">
  <div><a [routerLink]="['/application']">New Permit Application</a></div>
  <div><a [routerLink]="['/login']">Customer Sign In</a></div>
  <div><a href="assets/HydrantPermitUserManual.pdf" target="_blank">User Manual</a></div>
  <div><a href="assets/HydrantOperation.pdf" target="_blank">Hydrant Operation</a></div>
  <div><a href="assets/HydrotrakConditionsofPermit.pdf" target="_blank">Terms and Conditions</a></div>
  <div><a href="assets/HydrotrakPortalTC.pdf" target="_blank">Terms of Use</a></div>
  <div><a href="https://www.youtube.com/watch?v=kNUBf7GMk9A&list=UU7ZwQ2SmU952NRs1-KtKYFg&index=0" target="_blank">Watch
      Hydrotrak Video</a></div>
</div>